


import React, { startTransition, useEffect, useState } from 'react';
import styles from '../../assets/scss/Invoice/InvoiceTable.module.scss';
import { FaEye, FaEdit, FaEllipsisV, FaChevronUp, FaChevronDown, FaPrint } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    useAssignInvoiceMutation,
    useCancelInvoiceMutation,
    useGetMyEmployeesQuery,
    useGetMyInvoicesQuery,
    useGetMyVendorsQuery,
    useUpdateInvoiceStatusByStoreMutation,
    useUpdateLogisticStatusMutation
} from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import { getUserInfo } from '../../utils/user.util';
import MyInvoice from './MyInvoice';
import InvoicePrintDesign from './InvoicePrintDesign';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';
import { capitalize } from '../../utils/capitalize';

const InvoiceTable = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('');
    const [storeId, setStoreId] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [assignedToMap, setAssignedToMap] = useState({});
    //const [activeTab, setActiveTab] = useState('invoiceOverview');


    //print code start
    const [showPrintPopup, setShowPrintPopup] = useState(false);
    const [selectedBill, setSelectedBill] = useState(null);
    const [activeTabs, setActiveTabs] = useState("thermal");



    // print code end

    const [confirmModalOpen, setConfirmModalOpen] = React.useState(false);
    const [invoiceToApprove, setInvoiceToApprove] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "invoiceOverview";

    const setActiveTab = (tab) => {
        setSearchParams({ tab });
    };
    const user = getUserInfo();

    const [showStats, setShowStats] = useState(false);



    const userPermissions = user?.roles?.flatMap((role) =>
        role?.permissions?.filter((perm) => perm?.isActive)
    ) || [];

    const hasFullAccessToInvoice = userPermissions.some(
        (perm) => perm.functionality === 'invoice' && perm.permissionType === 'fullaccess'
    );

    //console.log(userPermissions, "hasFullAccessToInvoice");

    const canViewInvoice = hasFullAccessToInvoice || userPermissions.some(
        (perm) => perm.functionality === 'invoice' && perm.permissionType === 'view only'
    );

    const canUpdateStatus = hasFullAccessToInvoice || userPermissions.some(
        (perm) => perm.functionality === 'invoice' && perm.permissionType === 'status update'
    );

    const canUpdateStatusInvoice = hasFullAccessToInvoice || canUpdateStatus;

    const canUpdateInvoice = hasFullAccessToInvoice || userPermissions.some(
        (perm) => perm.functionality === 'invoice' && perm.permissionType === 'update'
    );

    const hasMyInvoiceFullAccess = user?.type === 'farmer' &&
        user?.roles?.some(role =>
            role?.permissions?.some(
                p =>
                    p?.functionality === 'myinvoice' &&
                    p?.permissionType === 'fullaccess' &&
                    p?.isActive
            )
        );

    //const hasFarmerInvoiceFullAccess = user?.type === 'farmer' &&

    user?.roles?.some(role =>
        role?.permissions?.some(
            p =>
                p?.functionality === 'invoice' &&
                p?.permissionType === 'fullaccess' &&
                p?.isActive
        )
    );

    //const offset = (currentPage - 1) + 1;

    const offset = currentPage;


    const [dropdownOpen, setDropdownOpen] = useState(null);
    const [cancelInvoice] = useCancelInvoiceMutation();
    const [updateLogisticStatus] = useUpdateLogisticStatusMutation();
    const [updateInvoiceStatusByStore] = useUpdateInvoiceStatusByStoreMutation();


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(`.${styles.dropdownWrapper}`)) {
                setDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const { data, isLoading } = useGetMyInvoicesQuery({
        offset,
        limit,
        status,
        invoiceStore: storeId,
        search,
        fromDate: fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : undefined,
        toDate: toDate ? dayjs(toDate).format('YYYY-MM-DD') : undefined
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [storeId, search, fromDate, toDate, status]);

    const { data: empData } = useGetMyEmployeesQuery();
    const employees = empData?.result || [];

    const { data: vendorData } = useGetMyVendorsQuery();
    const stores = vendorData?.stores || [];

    const [assignInvoice] = useAssignInvoiceMutation();

    const invoices = data?.invoices || [];
    const totalPages = Math.ceil((data?.total || 0) / limit);



    useEffect(() => {
        if (!invoices || invoices.length === 0) return;

        const initialMap = {};

        invoices.forEach((inv) => {
            if (typeof inv.assignedTo === 'object' && inv.assignedTo?._id) {
                initialMap[inv._id] = inv.assignedTo._id;
            } else if (typeof inv.assignedTo === 'string') {
                initialMap[inv._id] = inv.assignedTo;
            }
        });

        setAssignedToMap(prev => {
            const isSame = JSON.stringify(prev) === JSON.stringify(initialMap);
            return isSame ? prev : initialMap;
        });
    }, [JSON.stringify(invoices)]);



    // const handleDeleteClick = (invoiceId) => {
    //     setSelectedInvoiceId(invoiceId);
    //     setModalOpen(true);
    // };




    const confirmDelete = async () => {
        try {
            const res = await cancelInvoice(selectedInvoiceId).unwrap();
            toast.success(res?.message || 'Invoice cancelled successfully.');
            setDropdownOpen(null);
        } catch (err) {
            const message = err?.data?.message || 'Failed to cancel invoice.';
            toast.error(message);
        } finally {
            setModalOpen(false);
            setSelectedInvoiceId(null);
        }
    };



    const handleCreateInvoiceClick = () => {
        navigate('/dashboard/CreateInvoice');
    };

    return (
        <div >
            {hasMyInvoiceFullAccess ? (
                <div className={styles.invoicemy}>
                    <div className={styles.header}><h3 className={styles.margin}>My Invoice</h3></div>
                    <MyInvoice />

                </div>
            ) : (
                <div className={styles.orderContainer}>
                    <div>


                        <div className={styles.tabButtons}>
                            <div className={styles.dflex}>
                                <button
                                    className={`${styles.tabButton} ${activeTab === 'invoiceOverview' ? styles.active : ''}`}
                                    onClick={() => setActiveTab('invoiceOverview')}
                                >
                                    Invoice Overview
                                </button>
                                {canViewInvoice  && (

                                    <button
                                        className={`${styles.tabButton} ${activeTab === 'myInvoice' ? styles.active : ''}`}
                                        onClick={() => setActiveTab('myInvoice')}
                                    >
                                        My Invoice
                                    </button>
                                )}
                            </div>

                            <div className={styles.statsHeader}>
                                <button
                                    className={styles.collapseBtn}
                                    onClick={() => setShowStats(prev => !prev)}
                                >
                                    {showStats ? (
                                        <FaChevronUp className={styles.collapseBtnicon} />
                                    ) : (
                                        <FaChevronDown className={styles.collapseBtnicon} />
                                    )}
                                </button>
                            </div>
                        </div>


                        {activeTab === 'invoiceOverview' && (
                            <>
                                {/* <h3 className={styles.margintop}>Invoice Overview</h3> */}
                                <div className={styles.statsCards}>
                                    {showStats && (
                                        <>
                                            <div className={`${styles.card} ${styles.total}`}>
                                                <h4 className={styles.margin}>Total Invoice</h4>
                                                <h2 className={styles.marginnum}>{data?.total || 0}</h2>
                                                <p className={styles.marginday}>Current Month</p>
                                            </div>

                                            <div className={`${styles.card} ${styles.attention}`}>
                                                <h4 className={styles.margin}>Invoice Need Attention</h4>
                                                <h2 className={styles.marginnum}>{data?.needAttentionCount || 0}</h2>
                                                <p className={styles.marginday}>Current Month</p>
                                            </div>

                                        </>
                                    )}


                                    <div className={styles.header}>
                                        <div className={styles.filterRow}>
                                            <div className={styles.filterRows}>
                                                <input
                                                    type="text"
                                                    placeholder="Search here..."
                                                    className={styles.searchInput}
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                                <select
                                                    className={styles.inputs}
                                                    value={storeId}
                                                    onChange={(e) => setStoreId(e.target.value)}
                                                >
                                                    <option value="">Store Name</option>
                                                    {stores.map((store) => (
                                                        <option key={store.userId} value={store.userId}>
                                                            {store.storeName}
                                                        </option>
                                                    ))}
                                                </select>
                                                <select
                                                    className={styles.inputs}
                                                    value={status}
                                                    onChange={(e) => setStatus(e.target.value)}
                                                >
                                                    <option value="">Invoice Status</option>
                                                    <option value="pending">Pending</option>
                                                    <option value="created">Created</option>
                                                    <option value="accept">Accepted</option>
                                                </select>


                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={(date) => setFromDate(date)}
                                                    dateFormat="dd.MM.yyyy"
                                                    placeholderText="From Date"
                                                    maxDate={new Date()}
                                                    isClearable
                                                    className={styles.inputss}
                                                />
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={(date) => setToDate(date)}
                                                    dateFormat="dd.MM.yyyy"
                                                    placeholderText="To Date"
                                                    maxDate={new Date()}
                                                    isClearable
                                                    className={styles.inputss}
                                                />


                                                <button
                                                    className={styles.clearBtn}
                                                    onClick={() => {
                                                        setSearch('');
                                                        setStatus('');
                                                        setStoreId('');
                                                        setFromDate(null);
                                                        setToDate(null);
                                                    }}
                                                >
                                                    Clear All
                                                </button>

                                                {hasFullAccessToInvoice && (
                                                    <button onClick={handleCreateInvoiceClick} className={styles.addBtn}>
                                                        + Create Invoice
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.tableWrapper}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Invoice No</th>
                                                    <th>Invoice From</th>
                                                    <th>Invoice Date</th>
                                                    <th>Invoice Status</th>
                                                    <th>Transport Status</th>
                                                    <th>Amount</th>
                                                    <th>Created By</th>
                                                    {hasFullAccessToInvoice && (
                                                        <th>Assigned To</th>
                                                    )}

                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="9" className={styles.noData}>Loading...</td>
                                                    </tr>
                                                ) : invoices.length > 0 ? (
                                                    invoices.map((inv) => (
                                                        <tr key={inv._id}>
                                                            <td className="notranslate">{inv.invoiceNumber}</td>
                                                            <td>{inv.creatorStore?.storeName ? capitalize(inv.creatorStore.storeName) : '-'}</td>
                                                            <td>{new Date(inv.createdAt).toLocaleDateString()}</td>
                                                            <td>
                                            <span className={`${styles.status} ${
                                                inv.status?.toLowerCase() === "approved" || inv.status?.toLowerCase() === "completed" || inv.status?.toLowerCase() === "dispatched"
                                                ? styles.statusApproved
                                                : inv.status?.toLowerCase() === "pending" || inv.status?.toLowerCase() === "created"
                                                ? styles.statusPending
                                                : inv.status?.toLowerCase() === "readyforpickup" || inv.status?.toLowerCase() === "readyforbilling"
                                                ? styles.statusWarning
                                                : inv.status?.toLowerCase() === "rejected" || inv.status?.toLowerCase() === "cancelled"
                                                ? styles.statusRejected
                                                : styles.statusDefault
                                            }`}>
                                                {inv.status ? capitalize(inv.status) : '-'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={`${styles.status} ${
                                                inv.logisticStatus?.toLowerCase() === "approved" || inv.logisticStatus?.toLowerCase() === "completed" || inv.logisticStatus?.toLowerCase() === "dispatched" || inv.logisticStatus?.toLowerCase() === "delivered"
                                                ? styles.statusApproved
                                                : inv.logisticStatus?.toLowerCase() === "pending" || inv.logisticStatus?.toLowerCase() === "ontheway"
                                                ? styles.statusPending
                                                : inv.logisticStatus?.toLowerCase() === "readyforpickup" || inv.logisticStatus?.toLowerCase() === "readyforbilling"
                                                ? styles.statusWarning
                                                : inv.logisticStatus?.toLowerCase() === "rejected" || inv.logisticStatus?.toLowerCase() === "cancelled"
                                                ? styles.statusRejected
                                                : styles.statusDefault
                                            }`}>
                                                {inv.logisticStatus ? capitalize(inv.logisticStatus) : '-'}
                                            </span>
                                        </td>
                                                            <td>₹{inv.amount}</td>
                                                            <td>{inv.createdBy?.userName ? capitalize(inv.createdBy.userName) : '-'}</td>
                                                            {hasFullAccessToInvoice && (

                                                                <td>
                                                                    <select
                                                                        className={`${styles.inputsselect} ${inv.logisticStatus !== 'delivered' || inv.status === 'approved'
                                                                            ? styles.disabledSelect
                                                                            : ''
                                                                            }`}
                                                                        value={assignedToMap[inv._id] || ''}
                                                                        disabled={
                                                                            inv.logisticStatus !== 'delivered' || inv.status === 'approved'
                                                                        }
                                                                        onChange={async (e) => {
                                                                            const employeeId = e.target.value;
                                                                            setAssignedToMap((prev) => ({
                                                                                ...prev,
                                                                                [inv._id]: employeeId,
                                                                            }));

                                                                            if (employeeId) {
                                                                                try {
                                                                                    await assignInvoice({
                                                                                        invoiceId: inv._id,
                                                                                        assignedTo: employeeId,
                                                                                    });
                                                                                    toast.success('Invoice assigned successfully!');
                                                                                } catch (err) {
                                                                                    toast.error(err?.data?.message || 'Failed to assign invoice');
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value="">Select Employee</option>
                                                                        {employees.map((emp) => (
                                                                            <option key={emp._id} value={emp._id}>
                                                                                {emp.firstName} {emp.lastName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>

                                                            )}


                                                            <td>
                                                                <div className={styles.actions}>


                                                                    {canViewInvoice && (
                                                                        <FaEye
                                                                            className={styles.icon}
                                                                            onClick={() =>
                                                                                navigate('/dashboard/CreateInvoice', {
                                                                                    state: { viewOnly: true, invoiceId: inv._id }
                                                                                })
                                                                            }
                                                                        />
                                                                    )}


                                                                    {canUpdateInvoice && inv.status !== 'approved' && (
                                                                        <FaEdit
                                                                            className={styles.icon}
                                                                            onClick={() =>
                                                                                navigate('/dashboard/CreateInvoice', {
                                                                                    state: { editMode: true, invoiceId: inv._id }
                                                                                })
                                                                            }
                                                                        />
                                                                    )}


                                                                    <>
                                                                        <FaPrint
                                                                            className={styles.icon}
                                                                            onClick={() => {
                                                                                setSelectedBill(inv);
                                                                                setActiveTabs("thermal");
                                                                                setShowPrintPopup(true);
                                                                            }}
                                                                        />

                                                                    </>



                                                                    {/* {user?.type === "employee" &&  inv.status !== "approved" && (
                                                                        <button
                                                                            className={styles.cancelButton}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    await updateInvoiceStatusByStore({
                                                                                        invoiceId: inv._id,
                                                                                        status: "approved",
                                                                                    }).unwrap();
                                                                                    toast.success("Invoice Approved");
                                                                                } catch (err) {
                                                                                    const errorMessage =
                                                                                        err?.data?.message || "Failed to approve invoice";
                                                                                    toast.error(errorMessage);
                                                                                }
                                                                            }}
                                                                        >
                                                                            Approve
                                                                        </button>
                                                                    )} */}

                                                                    {/* {canUpdateStatusInvoice && inv.status !== "approved" && (
                                                                        <button
                                                                            className={styles.cancelButton}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    await updateInvoiceStatusByStore({
                                                                                        invoiceId: inv._id,
                                                                                        status: "approved",
                                                                                    }).unwrap();
                                                                                    toast.success("Invoice Approved");
                                                                                } catch (err) {
                                                                                    const errorMessage =
                                                                                        err?.data?.message || "Failed to approve invoice";
                                                                                    toast.error(errorMessage);
                                                                                }
                                                                            }}
                                                                        >
                                                                            Approve
                                                                        </button>
                                                                    )} */}

                                                                    {canUpdateStatusInvoice && inv.status !== "approved" && user?.type !== "logistic" && (
                                                                        <button
                                                                            className={styles.approveButton}
                                                                            onClick={() => {
                                                                                setInvoiceToApprove(inv); // store the invoice being approved
                                                                                setConfirmModalOpen(true); // open confirmation modal
                                                                            }}
                                                                            disabled={loading}
                                                                        >
                                                                            {loading ? "Approving..." : "Approve"}
                                                                        </button>
                                                                    )}

                                                                    {inv.status === "pending" &&
                                                                        (user?.type === "wholesaleowner" || user?.type === "siteadmin") && (
                                                                            <div className={styles.actionWrapper}>
                                                                                <button
                                                                                    className={styles.cancelButton}
                                                                                    onClick={() => {
                                                                                        setSelectedInvoiceId(inv._id);
                                                                                        setModalOpen(true);
                                                                                    }}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                    {user?.type === "logistic" && (
                                                                        <div className={styles.actionWrapper}>
                                                                            {inv.status?.toLowerCase() !== "approved" &&
                                                                                inv.logisticStatus !== "intransist" &&
                                                                                inv.logisticStatus !== "delivered" && (
                                                                                    <>
                                                                                        <button
                                                                                            className={styles.approveButton}
                                                                                            disabled={inv.logisticStatus === "accepted"}
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    await updateLogisticStatus({
                                                                                                        invoiceId: inv._id,
                                                                                                        logisticStatus: "accepted",
                                                                                                    }).unwrap();
                                                                                                    toast.success("Invoice Accepted");
                                                                                                } catch (err) {
                                                                                                    const errorMessage =
                                                                                                        err?.data?.message || "Failed to update status";
                                                                                                    toast.error(errorMessage);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            Accept
                                                                                        </button>

                                                                                        <button
                                                                                            className={styles.approveButton}
                                                                                            disabled={inv.logisticStatus === "cancelled"}
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    await updateLogisticStatus({
                                                                                                        invoiceId: inv._id,
                                                                                                        logisticStatus: "cancelled",
                                                                                                    }).unwrap();
                                                                                                    toast.success("Invoice Cancelled");
                                                                                                } catch (err) {
                                                                                                    const errorMessage =
                                                                                                        err?.data?.message || "Failed to update status";
                                                                                                    toast.error(errorMessage);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            Reject
                                                                                        </button>
                                                                                    </>
                                                                                )}

                                                                            {inv.logisticStatus === "accepted" && (
                                                                                <button
                                                                                    className={styles.approveButton}
                                                                                    onClick={async () => {
                                                                                        try {
                                                                                            await updateLogisticStatus({
                                                                                                invoiceId: inv._id,
                                                                                                logisticStatus: "intransist",
                                                                                            }).unwrap();
                                                                                            toast.success("Marked as In Transit");
                                                                                        } catch (err) {
                                                                                            const errorMessage =
                                                                                                err?.data?.message || "Failed to update status";
                                                                                            toast.error(errorMessage);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    In Transit
                                                                                </button>
                                                                            )}

                                                                            {inv.logisticStatus === "intransist" && (
                                                                                <button
                                                                                    className={styles.approveButton}
                                                                                    onClick={async () => {
                                                                                        try {
                                                                                            await updateLogisticStatus({
                                                                                                invoiceId: inv._id,
                                                                                                logisticStatus: "delivered",
                                                                                            }).unwrap();
                                                                                            toast.success("Invoice Delivered");
                                                                                        } catch (err) {
                                                                                            const errorMessage =
                                                                                                err?.data?.message || "Failed to update status";
                                                                                            toast.error(errorMessage);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    Delivered
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {/* corrected code like 3 dot code snippet starts here */}
                                                                    {/* <div className={styles.dropdownWrapper}>
                                                                        <button
                                                                            className={styles.dropdownToggle}
                                                                            onClick={() =>
                                                                                setDropdownOpen((prev) => (prev === inv._id ? null : inv._id))
                                                                            }
                                                                        >
                                                                            <FaEllipsisV className={styles.icon} />
                                                                        </button>

                                                                        {dropdownOpen === inv._id &&
                                                                            inv.status === "pending" &&
                                                                            (user?.type === "wholesaleowner" || user?.type === "siteadmin") && (
                                                                                <div className={styles.dropdownMenu}>
                                                                                    <button
                                                                                        className={styles.dropdownItem}
                                                                                        onClick={() => {
                                                                                            setSelectedInvoiceId(inv._id);
                                                                                            setModalOpen(true);
                                                                                        }}
                                                                                    >
                                                                                        Cancel Invoice
                                                                                    </button>
                                                                                </div>
                                                                            )}

                                                                        {dropdownOpen === inv._id &&
                                                                            canUpdateStatus &&
                                                                            user?.type !== "siteadmin" &&
                                                                            user?.type !== "wholesaleowner" && (
                                                                                <div className={styles.dropdownMenu}>
                                                                                    {user?.type === "employee" && inv.status !== "approved" && (
                                                                                        <button
                                                                                            className={styles.dropdownItem}
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    await updateInvoiceStatusByStore({
                                                                                                        invoiceId: inv._id,
                                                                                                        status: "approved",
                                                                                                    }).unwrap();
                                                                                                    toast.success("Invoice Approved");
                                                                                                } catch (err) {
                                                                                                    const errorMessage =
                                                                                                        err?.data?.message || "Failed to approve invoice";
                                                                                                    toast.error(errorMessage);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            Approve
                                                                                        </button>
                                                                                    )}

                                                                                    {inv.logisticStatus !== "intransist" &&
                                                                                        inv.logisticStatus !== "delivered" && (
                                                                                            <>
                                                                                                <button
                                                                                                    className={styles.dropdownItem}
                                                                                                    disabled={inv.logisticStatus === "accepted"}
                                                                                                    onClick={async () => {
                                                                                                        try {
                                                                                                            await updateLogisticStatus({
                                                                                                                invoiceId: inv._id,
                                                                                                                logisticStatus: "accepted",
                                                                                                            }).unwrap();
                                                                                                            toast.success("Invoice Accepted");
                                                                                                        } catch (err) {
                                                                                                            const errorMessage =
                                                                                                                err?.data?.message || "Failed to update status";
                                                                                                            toast.error(errorMessage);
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    Accept
                                                                                                </button>

                                                                                                <button
                                                                                                    className={styles.dropdownItem}
                                                                                                    disabled={inv.logisticStatus === "cancelled"}
                                                                                                    onClick={async () => {
                                                                                                        try {
                                                                                                            await updateLogisticStatus({
                                                                                                                invoiceId: inv._id,
                                                                                                                logisticStatus: "cancelled",
                                                                                                            }).unwrap();
                                                                                                            toast.success("Invoice Cancelled");
                                                                                                        } catch (err) {
                                                                                                            const errorMessage =
                                                                                                                err?.data?.message || "Failed to update status";
                                                                                                            toast.error(errorMessage);
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    Reject
                                                                                                </button>
                                                                                            </>
                                                                                        )}

                                                                                    {inv.logisticStatus === "accepted" && (
                                                                                        <button
                                                                                            className={styles.dropdownItem}
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    await updateLogisticStatus({
                                                                                                        invoiceId: inv._id,
                                                                                                        logisticStatus: "intransist",
                                                                                                    }).unwrap();
                                                                                                    toast.success("Marked as In Transit");
                                                                                                } catch (err) {
                                                                                                    const errorMessage =
                                                                                                        err?.data?.message || "Failed to update status";
                                                                                                    toast.error(errorMessage);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            In Transit
                                                                                        </button>
                                                                                    )}

                                                                                    {inv.logisticStatus === "intransist" && (
                                                                                        <button
                                                                                            className={styles.dropdownItem}
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    await updateLogisticStatus({
                                                                                                        invoiceId: inv._id,
                                                                                                        logisticStatus: "delivered",
                                                                                                    }).unwrap();
                                                                                                    toast.success("Invoice Delivered");
                                                                                                } catch (err) {
                                                                                                    const errorMessage =
                                                                                                        err?.data?.message || "Failed to update status";
                                                                                                    toast.error(errorMessage);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            Delivered
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                    </div> */}

                                                                    {/* corrected code like 3 dot code snippet starts here */}

                                                                </div>
                                                            </td>


                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className={styles.noData}>No Invoices Found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className={styles.paginationWrapper}>
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={setCurrentPage}
                                        />
                                        <select
                                            className={styles.inputsbtn}
                                            value={limit}
                                            onChange={(e) => {
                                                setLimit(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <option value={10}>10 rows</option>
                                            <option value={25}>25 rows</option>
                                            <option value={50}>50 rows</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        {activeTab === 'myInvoice' && (
                            <div className={styles.tabContent}>
                                {/* <h3 className={styles.margintop}>My Invoice</h3> */}
                                <MyInvoice />
                            </div>
                        )}



                        <DeleteConfirmModal
                            isOpen={isModalOpen}
                            onClose={() => setModalOpen(false)}
                            onConfirm={confirmDelete}
                        />

                        {showPrintPopup && selectedBill && (
                            <PopupWrapper onClose={() => setShowPrintPopup(false)}>
                                <div className={styles.popupHeader}>
                                    <div className={styles.headers}>
                                        <h2 className={styles.tittle}>Share</h2>
                                        <span className={styles.closeIcon} onClick={() => setShowPrintPopup(false)}>✕</span>
                                    </div>

                                    {/* Tab Buttons */}
                                    <div className={styles.tabHeader}>
                                        <button
                                            className={activeTabs === "thermal" ? styles.activeTabs : ""}
                                            onClick={() => setActiveTabs("thermal")}
                                        >
                                            Thermal Print
                                        </button>
                                        <button
                                            className={activeTabs === "whatsapp" ? styles.activeTabs : ""}
                                            onClick={() => setActiveTabs("whatsapp")}
                                        >
                                            WhatsApp Share
                                        </button>
                                    </div>

                                    {/* Tab Content */}
                                    <div className={styles.tabContent}>
                                        {activeTabs === "thermal" && (
                                            <div className={styles.invoicePreview}>
                                                <InvoicePrintDesign
                                                    mode="thermal"
                                                    data={selectedBill}
                                                />
                                            </div>
                                        )}

                                        {activeTabs === "whatsapp" && (
                                            <div className={styles.whatsappShare}>
                                                <InvoicePrintDesign
                                                    mode="whatsapp"
                                                    data={selectedBill}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </PopupWrapper>
                        )}

                    </div>
                    <DeleteConfirmModalLogout
                        isOpen={confirmModalOpen}
                        title="Are you sure?"
                        heading="Confirm Approval"
                        // content="Once approved, you will not be able to undo this action. Do you want to continue?"
                        content="Save or review the items before approval. Once approved, you will not be able to undo this action. Do you want to continue?"
                        onCancel={() => {
                            setConfirmModalOpen(false);
                            setInvoiceToApprove(null);
                        }}
                        onConfirm={async () => {
                            if (!invoiceToApprove) return;
                            setLoading(true);
                            try {
                                await updateInvoiceStatusByStore({
                                    invoiceId: invoiceToApprove._id,
                                    status: "approved",
                                }).unwrap();
                                toast.success("Invoice Approved");
                            } catch (err) {
                                const errorMessage = err?.data?.message || "Failed to approve invoice";
                                toast.error(errorMessage);
                            } finally {
                                setLoading(false);
                                setConfirmModalOpen(false);
                                setInvoiceToApprove(null);
                            }
                        }}
                    />
                </div>
            )}


        </div>
    );
};

export default InvoiceTable;
